import React, {useState} from "react";

export const KpiContext = React.createContext('');

export const KpiProvider = ({value, children}) => {

    const [fieldKpiFocus, setFieldKpiFocus] = useState();

    function setIdFieldKpiFocus(id) {
        setFieldKpiFocus(id)
    }

    function resetIdFieldKpiFocus() {
        setFieldKpiFocus(null);
    }

    return (
        <KpiContext.Provider
            value={{
                fieldKpiFocus,
                setIdFieldKpiFocus,
                resetIdFieldKpiFocus,
            }}>{children}</KpiContext.Provider>
    );
};
